import { GQL_ID } from '@@types'
import { gql, useMutation } from '@apollo/client'

import type { UpdateCartProductResult } from '../types'

const UPDATE_CART_PRODUCT_AMOUNT_MUTATION = gql`
  mutation UpdateCartProductAmount($itemData: CartDataInput!, $shopId: ID!) {
    updateCartProductAmount(itemData: $itemData, shop_id: $shopId) {
      product_id
      message
      max_amount
      productInfo {
        name
        id
      }
    }
  }
`

export interface CartDataInput {
  product_id: GQL_ID
  amount: number
}

export interface UpdateCartProductAmountVariables {
  itemData: CartDataInput
  shopId: GQL_ID
}

export interface UpdateCartProductAmountResponse {
  updateCartProductAmount: UpdateCartProductResult
}

export function useMutateUpdateCartProductAmount () {
  return useMutation<UpdateCartProductAmountResponse, UpdateCartProductAmountVariables>(
    UPDATE_CART_PRODUCT_AMOUNT_MUTATION
  )
}
